import React from "react";
//change this svg for internal server error
import NotFound from "../../Assets/404error.svg";
import Button from "@material-ui/core/Button";
import { NavLink } from "react-router-dom";
import "./InternalServerError.styles.scss";

const InternalServerError = () => (
  <div className="error_container">
    <div id="error_image_container">
      <img src={NotFound} alt="PageNotFound" />
    </div>
    <div id="error_desc_container" style={{ lineHeight: "1rem" }}>
      <p
        style={{
          textAlign: "center",
          fontWeight: "bolder",
          fontSize: "1.5rem",
        }}
      >
        Sorry, server is down!
      </p>
      <p
        style={{
          fontWeight: "bold",
          fontSize: "1rem",
        }}
      >
        Server couldn't process request
      </p>
    </div>
    <div id="error_redirect_console">
      <Button variant="contained" color="primary">
        <NavLink style={{ color: "white" }} to="/console">
          Return to Dashboard
        </NavLink>
      </Button>
    </div>
  </div>
);

export default InternalServerError;
